import PropTypes from 'prop-types';
import React from 'react';
import { TAG_DEFAULT_COLOR } from 'app/constants/Colors';

export default function Tag({ size = '100%', color = TAG_DEFAULT_COLOR }) {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
      <path
        fill={color}
        d="M13.8,0.2L13.8,0.2
        C13.7,0.1,13.5,0,13.4,0l-6,0.2C7.2,0.2,7.1,0.2,7,0.3L0.2,7.1c-0.2,0.2-0.2,0.6,0,0.9
        L6,13.8c0.2,0.2,0.6,0.2,0.9,0L13.7,7c0.1-0.1,0.2-0.3,0.2-0.4l0.2-6C14,0.5,13.9,0.3,13.8,0.2z
        M10.7,4.5C10,4.5,9.5,4,9.5,3.3
        C9.5,2.6,10,2,10.7,2C11.4,2,12,2.6,12,3.3C12,4,11.4,4.5,10.7,4.5z"
      />
    </svg>
  );
}

Tag.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.string,
};
